import performRequest from '../../axios';

export const courseAPI = {
  createCourse: async (body) => {
    return await performRequest('course', 'POST', body);
  },

  updateCourse: async (body, id) => {
    return await performRequest(`course/${id}`, 'PATCH', body);
  },

  getSpecificCourse: async (id) => {
    return await performRequest(`course/${id}`, 'GET');
  },

  updateImageAndTrailer: async (body, id) => {
    return await performRequest(`course/links/${id}`, 'PATCH', body);
  },

  updateCourseStatus: async (body, id) => {
    return await performRequest(`updateStatus/${id}`, 'PATCH', body);
  },

  getCoursesByPage: async (pageNumber) => {
    return await performRequest(`courses/${pageNumber}`, 'GET');
  },

  getUserCourses: async (pageNumber, status, searchValue) => {
    let query = '';
    if (searchValue) {
      query += `?search=${searchValue}`;
    }
    if (status) {
      if (query) {
        query += `&status=${status}`;
      } else {
        query += `?status=${status}`;
      }
    }

    return await performRequest(`v2/user/courses/${pageNumber}${query}`, 'GET');
  },

  searchCourse: async (searchKeyword) => {
    return await performRequest(`courses/1?search=${searchKeyword}`, 'GET');
  },

  deleteCourse: async (id) => {
    return await performRequest(`course/${id}`, 'DELETE');
  },

  getAllUsers: async (includeSelf) => {
    return await performRequest(`search/user?search=&includeSelf=${includeSelf}`, 'GET');
  },

  getUsers: async (searchQuery) => {
    return await performRequest(`search/user?search=${searchQuery}`, 'GET');
  },

  assignAccessToUser: async (body) => {
    return await performRequest(`user/access`, 'POST', body);
  },

  getAccessAssignees: async (id) => {
    return await performRequest(`user/access/${id}`, 'GET');
  },

  getCourseUserHasAccessTo: async (id) => {
    return await performRequest(`access/COURSE/0`, 'GET');
  },

  deleteAccessAssignee: async (username, courseId) => {
    return await performRequest(`user/access/${username}/${courseId}`, 'DELETE');
  },
  searchEnrolledUsers: async (courseId, pageNo = 1, level = 'USER', searchValue = "") => {
    return await performRequest(`enrolled/users/${courseId}/${pageNo}?level=${level}&search=${searchValue}`, 'GET');
  },
  searchEnrolledUsersData: async (courseId, userId) => {
    return await performRequest(`enrolled/user/progress/${courseId}/${userId}`, 'GET');
  },
  enrollUsers: async (courseId, body) => {
    return await performRequest(`enroll/users/${courseId}`, 'POST', body);
  },
  getCourseContentSuggestion: async (courseId, sectionId) => {
    return await performRequest(`/course-content-suggestion/${courseId}/${sectionId}`, 'GET');
  },

  markSuggestionUsed: async (courseId, body) => {
    return await performRequest(`course-content-suggestion/${courseId}`, 'PATCH', body);
  },

  updateCertificateConfig: async (courseId, body) => {
    return await performRequest(`api/course/${courseId}/certificate/config`, 'PATCH', body);
  },

  generateCertificate: async (courseId) => {
    return await performRequest(`api/course/${courseId}/certificate/generate`, 'GET');
  },

  bulkGenerateCertificates: async (courseId, body) => {
    return await performRequest(`api/course/${courseId}/certificate/bulk-generate`, 'POST', body);
  }
};
